import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import { getSalesReport } from '@/api/scm/sales-report';
import moment from "moment";

export default extend(table, {
	namespaced: true,
	state: {
		salesReport: [],
		searchForm: {
			time: [Date.now() - 6 * 24 * 60 * 60 * 1000, Date.now() + 1 * 24 * 60 * 60 * 1000]
		}
	},
	actions: {
		async getSalesReport({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'scm.sales-report.index', async function () {
				const { searchForm } = state;
				const response = await getSalesReport({
					startTime: searchForm.time && moment(moment(searchForm.time[0]).format('YYYY-MM-DD')).valueOf() / 1000,
					endTime: searchForm.time && moment(moment(searchForm.time[1]).format('YYYY-MM-DD')).valueOf() / 1000,
				})
				if (response.data) {
					commit('save', {
						salesReport: response.data
					})
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/scm/sales-report/index.js